<template>
  <TicketsActionMenu class="d-flex justify-center">
    <TicketsActionMenuItem
      v-if="showEdit"
      icon="mdi-pencil-outline"
      @click.stop="$emit('edit')"
    >
      Edit
    </TicketsActionMenuItem>
    <TicketsActionMenuItem
      v-if="showInfo"
      icon="mdi-information-outline"
      @click.stop="$emit('info')"
    >
      Details
    </TicketsActionMenuItem>
    <TicketsActionMenuItem
      v-if="showDelete"
      icon="mdi-delete-outline"
      destructive
      @click.stop="$emit('delete')"
    >
      Delete
    </TicketsActionMenuItem>
  </TicketsActionMenu>
</template>

<script>
import TicketsActionMenu from "@/components/Tickets/TicketsActionMenu.vue";
import TicketsActionMenuItem from "@/components/Tickets/TicketsActionMenuItem.vue";

export default {
  name: "OrgSettingsTableActions",
  components: { TicketsActionMenu, TicketsActionMenuItem },
  props: {
    showEdit: { type: Boolean, default: true },
    showInfo: { type: Boolean, default: false },
    showDelete: { type: Boolean, default: true },
  },
  emits: ["edit", "info", "delete"],
};
</script>
